import {Space, VStack} from 'platform/foundation';

import {
  VehicleForm as VFKit,
  VehicleSubSections as VFSubSection,
  VehicleFormDefaultLayout,
  useIntegrationsEnabled,
  useIsCardExpandable,
} from '@dms/features/vehicle-forms-kit';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {usePermissions} from '@dms/shared';

import {openInNewTab} from 'shared/web';

import {AdditionalInfoWidget} from '../components/AdditionalInfoWidget';

export function ServiceFeatures() {
  const isExpandable = useIsCardExpandable();
  const {isCebiaFeatureDecoderEnabled} = useIntegrationsEnabled();

  const [canReadBusinessCase] = usePermissions({
    permissionKeys: ['businessCaseRead'],
  });

  return (
    <VehicleFormDefaultLayout>
      <VehicleFormDefaultLayout.Left>
        <VStack spacing={4}>
          <VFKit.Section
            data-testid="features"
            isExpandable={isExpandable}
            title={isExpandable ? i18n.t('general.labels.allFeatures') : undefined}
          >
            <VFSubSection.FeatureSelector />
          </VFKit.Section>
        </VStack>
      </VehicleFormDefaultLayout.Left>
      <VehicleFormDefaultLayout.Right>
        <VFKit.SubSection data-testid="additional-info">
          <AdditionalInfoWidget />
        </VFKit.SubSection>
        <Space vertical={4} />
        <VFKit.ShowWhen when={canReadBusinessCase && isCebiaFeatureDecoderEnabled}>
          <VFKit.SubSection
            data-testid="cebia-widgets"
            isExpandable={isExpandable}
            title={i18n.t('entity.vehicle.labels.integrations')}
            useCard
            cardVariant="inlineWhite"
            actions={[
              {
                variant: 'link',
                type: 'button',
                leftIcon: 'action/settings',
                onClick: () => openInNewTab(settingsRoutes.vehicleServices),
                title: i18n.t('general.labels.settings'),
              },
            ]}
          >
            <VFSubSection.FeatureAutofill />
          </VFKit.SubSection>
          <Space vertical={4} />
          <VFKit.ShowWhen when={canReadBusinessCase}>
            <VFKit.SubSection
              data-testid="feature-market-analysis"
              title={i18n.t('entity.vehicle.labels.featureMarketAnalysis')}
              isExpandable={isExpandable}
              cardVariant="inlineWhite"
              useCard
            >
              <VFKit.Suspense>
                <VFKit.FeatureMarketAnalysisWidget />
              </VFKit.Suspense>
            </VFKit.SubSection>
          </VFKit.ShowWhen>
        </VFKit.ShowWhen>
      </VehicleFormDefaultLayout.Right>
    </VehicleFormDefaultLayout>
  );
}
